import { IApplicationState } from '../../../../types/types';
import { ICardAssignees } from '../types';

export const getCardAssignees = (
    state: IApplicationState
): ICardAssignees => {
    return state.model.cardAssignees;
}
